"use strict";
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.omitIfNil = void 0;
/**
 * Creates a new object with none of the null or undefined attribute values from the given object. Does not recurse.
 * @param object - The base object
 * @returns a new object with the non-null and non-undefined values of the given object.
 */

const omitIfNil = object => {
  return Object.entries(object).filter(([, value]) => {
    return value !== null && value !== undefined;
  }).reduce((newObject, [key, value]) => Object.assign(newObject, {
    [key]: value
  }), {});
};

exports.omitIfNil = omitIfNil;